import cookie from 'js-cookie'
//import store from '../store'
import "../api/plugins/axios"

//获取uid和cookie的token
function getUidAndToken(route){
    let res={};
    res.token=cookie.get("token");
    res.uid=Number(route.params.id);
    return res;
}

//检查obj是否是空对象，空对象返回true，非空返回false
function isEmptyObject(obj) {
    // 确保变量是对象且不为 null
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }

    // 使用 Object.keys 获取对象自身可枚举属性的键数组
    return Object.keys(obj).length === 0;
}

export default {
    getUidAndToken,
    isEmptyObject,

}